import HistoryIcon from '@mui/icons-material/History'
import Chip from '@mui/material/Chip';
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Paper from '@mui/material/Paper';
import Select, { SelectChangeEvent } from "@mui/material/Select";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useState } from "react";
import { DownloadFormat } from "~/components/organisation/reporting/apiOrganisationSoftwareQuality";
import { useSoftwareQualityOverviewContext } from "~/components/organisation/reporting/SoftwareQualityOverviewContext";
import Stack from '@mui/material/Stack';
import HgfButton from '~/components/home/helmholtz/ui/HgfButton';

export function QualityReportDownloadHistory() {
  const ctx = useSoftwareQualityOverviewContext()

  const [open, setOpen] = useState(false);
  const [format, setFormat] = useState<DownloadFormat>('json');

  const handleFormatSelect = (event: SelectChangeEvent) => {
    setFormat(event.target.value as DownloadFormat)
  }

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const downloadSaved = (id: number) => {
    ctx.downloadSavedQualityReports(id, format)
  }

  return (
    <>
      <HgfButton style='secondary' size='small' onClick={handleOpen} className='w-full'><HistoryIcon />Download history</HgfButton>
      <Dialog
        open={open}
        onClose={handleClose}
        slotProps={{
          paper: {
            sx: {
              minWidth: '70vw',
              minHeight: '40vh',
              borderRadius: '4px'
            }
          }
        }}
      >
        <DialogTitle sx={{
          fontSize: '1.5rem',
          borderBottom: '1px solid',
          borderColor: 'divider',
          color: 'primary.main',
          fontWeight: 500
        }}>
          Previous downloads
        </DialogTitle>

        <DialogContent sx={{
          width: '100%',
          padding: '2rem 1.5rem 2.5rem'
        }}>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Report time</TableCell>
                  <TableCell>Changed?</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {...ctx.savedQualityReports.map((report) => {
                  const formattedDate = (new Date(report.timestamp)).toLocaleString()
                  return (
                    <TableRow key={report.id} hover={true} selected={report.is_new}>
                      <TableCell>{report.id}</TableCell>
                      <TableCell>{formattedDate}</TableCell>
                      <TableCell>
                        <Chip
                          label={report.is_new ? 'yes' : 'no'}
                          color={report.is_new ? 'success' : 'error'}
                          size="small"
                        />
                      </TableCell>
                      <TableCell>
                        <Stack direction="row" spacing={2}>
                          <FormControl size="small">
                            <InputLabel id="download-format-select-label">Format</InputLabel>
                            <Select
                              labelId="demo-format-select-label"
                              id="demo-format-select"
                              value={format}
                              label="Format"
                              onChange={handleFormatSelect}
                            >
                              <MenuItem value={'json'}>JSON</MenuItem>
                              <MenuItem value={'csv'}>CSV</MenuItem>
                            </Select>
                          </FormControl>
                          <HgfButton style='primary' size='small' onClick={() => downloadSaved(report.id)}>Download</HgfButton>
                        </Stack>
                      </TableCell>
                    </TableRow>
                  )
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
      </Dialog>
    </>
  )
}
